import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { isAirportTransferAgentLinkSearch } from 'hooks/Transfers/useTransferSearchParams'

// Stays true for the session, so going back to the search from checkout still works.
export default function useIsAirportTransferAgentLink(): boolean {
  const { search } = useLocation()
  const isAgentLink = isAirportTransferAgentLinkSearch(search)
  const [hasOpenedAgentLink, setHasOpenedAgentLink] = useState(isAgentLink)

  if (isAgentLink && !hasOpenedAgentLink) {
    setHasOpenedAgentLink(true)
  }

  return isAgentLink || hasOpenedAgentLink
}
